import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTopButton from "./ScrollToTopButton";
import { ReactNode } from "react";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen bg-background">
      {/* Skip to main content — accessibility */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-0 focus:left-0 focus:z-[100] focus:bg-primary focus:text-primary-foreground focus:px-6 focus:py-3 focus:text-sm focus:font-body focus:tracking-wider focus:uppercase"
      >
        Skip to main content
      </a>
      <div className="fixed top-0 left-0 right-0 z-[60] bg-primary text-primary-foreground text-center py-2 px-4">
        <a href="tel:2155692400" className="text-xs md:text-sm tracking-[0.15em] uppercase font-body hover:opacity-80 transition-opacity">
          Get in touch today <span className="font-semibold">(215) 569-2400</span>
        </a>
      </div>
      <div className="pt-10">
        <Navbar />
        <main id="main-content">{children}</main>
        <Footer />
        <ScrollToTopButton />
      </div>
    </div>
  );
};

export default Layout;
